/*
 * @Description:
 * @Author: rqcheng
 * @Date: 2023-10-09 14:08:44
 * @LastEditTime: 2025-06-20 15:38:09
 * @LastEditors: rqcheng
 */

export function getAccessToken() {
  return localStorage.getItem("token");
}

export function setAccessToken(token) {
  localStorage.setItem("token", token);
}

export function removeAccessToken() {
  localStorage.removeItem("token");
}

// &token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTcwNTQ4MzUzNSwianRpIjoiNDEyNWQzNWItNDk0Ni00YTc0LWJlNTgtODcwYTI2YTJkODAyIiwidHlwZSI6ImFjY2VzcyIsInN1YiI6NCwibmJmIjoxNzA1NDgzNTM1LCJleHAiOjE3MDU1Njk5MzV9.iRUXJQh7mMFeboLZupCpFMEVDmh0mTam-lP62shaY9E



// WEBPACK FOOTER //
// ./src/plugins/auth.js